var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
'sh-input',
{
    'sh-input-group': _vm.$slots.prepend || _vm.$slots.append,
}
]},[(_vm.type !== 'textarea')?[_c('input',_vm._b({ref:"input",attrs:{"type":_vm.type,"disabled":_vm.disabled,"readonly":_vm.readonly},on:{"focus":_vm.handleFocus,"blur":_vm.handleBlur,"input":_vm.handleInput}},'input',_vm.$attrs,false)),(_vm.$slots.append)?_c('div',{staticClass:"sh-input-group__append"},[_vm._t("append")],2):_vm._e()]:_c('textarea',_vm._b({ref:"textarea",attrs:{"disabled":_vm.disabled,"readonly":_vm.readonly},on:{"input":_vm.handleInput}},'textarea',_vm.$attrs,false))],2)}
var staticRenderFns = []

export { render, staticRenderFns }